import React, { FunctionComponent, ReactElement } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import useConfig from '@empiriecom/module-components/hooks/useConfig';
import { FragmentConfiguration } from '@/config';

const StyledInstallmentCalculatorFooter = styled.div<{ cardLayout: boolean }>`
  display: table;
  margin-top: ${({ cardLayout }) => (cardLayout ? '0.45rem;' : '1.25rem;')};
`;

const FooterColumn = styled.div`
  font-size: 0.688rem;
  display: table-row;
`;

const FooterCell = styled.div`
  display: table-cell;
  padding: 0.45rem 0;
  &&:not(:first-of-type) {
    padding-left: 0.5rem;
  }
`;

export const InstallmentCalculatorFooter: FunctionComponent = (): ReactElement => {
  const {
    installmentCalculator: { cardLayout },
  } = useConfig<FragmentConfiguration>();
  return (
    <StyledInstallmentCalculatorFooter cardLayout={cardLayout}>
      <FooterColumn>
        <FooterCell>
          <FormattedMessage
            id="installment-calculator.footer.p1"
            defaultMessage="Für die Zahlpause (erst in 4 Monaten bezahlen) wird ein zusätzlicher Aufschlag von 4,13% auf den Warenwert berechnet."
          />
        </FooterCell>
      </FooterColumn>
      <FooterColumn>
        <FooterCell>
          <FormattedMessage
            id="installment-calculator.footer.p2"
            defaultMessage="Bitte beachte, dass die Raten ohne Versandkosten und Speditionsaufschläge ausgewiesen sind. Deine Aufschläge kannst du im Warenkorb in Schritt 4 einsehen."
          />
        </FooterCell>
      </FooterColumn>
    </StyledInstallmentCalculatorFooter>
  );
};

export default InstallmentCalculatorFooter;
